import { TreeList, Column } from "devextreme-react/tree-list";
import { Folder, RemoveTwoTone } from "@mui/icons-material";
import { Icon } from "@mui/material";
import CustomStore from "devextreme/data/custom_store";

interface IFolderProps {
  customDataSource?: CustomStore;
  setSelectedItemId?: React.Dispatch<React.SetStateAction<string | undefined>>;
}

function NewFolderListView({
  customDataSource,
  setSelectedItemId,
}: IFolderProps) {
  return (
    <>
      <TreeList
        dataSource={customDataSource}
        defaultExpandedRowKeys={[3]}
        keyExpr="id"
        parentIdExpr="parentId"
        showBorders={true}
        columnAutoWidth={true}
        rowAlternationEnabled={false}
        showRowLines={true}
        selection={{
          mode: "single",
        }}
        itemsExpr="children"
        onSelectionChanged={async (e: any) => {
          if (
            e.selectedRowKeys &&
            e.selectedRowKeys.length > 0 &&
            setSelectedItemId
          ) {
            setSelectedItemId(e.selectedRowKeys[0] ?? null);
          }
        }}
      >
        <Column
          dataField="name"
          caption="Folder Name"
          cellRender={(data) =>
            data.data.isGroup ? (
              <>
                <Icon component={Folder} /> {data.text}
              </>
            ) : (
              <>
                <Icon component={RemoveTwoTone} /> {data.text}
              </>
            )
          }
        />
      </TreeList>
    </>
  );
}

export default NewFolderListView;
